<template>
  <div class="field">
    <div class="fieldLabelRow">
      <span class="fieldLabel">{{ label }}<span v-if="optional" class="optional"> · optional</span></span>
      <InfoTip v-if="tip" :text="tip" />
    </div>
    <!-- Locked fields render their fixed value read-only (e.g. Business identity
         is always "Direct customer" — design 1c). -->
    <div v-if="locked" class="lockedValue">
      <span>{{ lockedLabel }}</span>
      <AppIcon name="agent_guardrail" :size="13" />
    </div>
    <slot v-else />
    <p v-if="error" class="fieldError">{{ error }}</p>
    <p v-else-if="hint" class="fieldHint">{{ hint }}</p>
  </div>
</template>

<script setup lang="ts">
import AppIcon from '../../../../components/AppIcon.vue'
import InfoTip from './InfoTip.vue'

defineProps<{
  label: string
  hint?: string
  error?: string
  tip?: string
  optional?: boolean
  locked?: boolean
  lockedLabel?: string
}>()
</script>

<style scoped>
.field { display: flex; flex-direction: column; gap: 6px; }
.fieldLabelRow { display: flex; align-items: center; gap: 6px; }
.fieldLabel { font-size: var(--fs-sm); font-weight: var(--fw-semibold); color: var(--color-text-primary); }
.optional { font-weight: var(--fw-regular); color: var(--color-text-tertiary); }
.fieldHint { margin: 0; font-size: var(--fs-xs); line-height: var(--lh-normal); color: var(--color-text-tertiary); }
.fieldError { margin: 0; font-size: var(--fs-xs); line-height: var(--lh-normal); color: var(--color-danger); }
.lockedValue {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 12px;
  border-radius: var(--radius-md);
  border: 1px solid var(--color-border-subtle);
  background: var(--color-bg-subtle);
  color: var(--color-text-secondary);
  font-size: var(--fs-sm);
}
.lockedValue :deep(svg) { color: var(--color-text-tertiary); }
</style>
